<script setup>
import './custom.scss';
import ThePanel from './components/ThePanel.vue';
import { onMounted } from 'vue';

onMounted(() => {
  // Ensure WordPress core is loaded
  if (typeof wp !== 'undefined' && wp.hooks) {
    // Initialize any WordPress-specific functionality here
  }
});
</script>


<template>
    <div class="smsir">
      <ThePanel/>

    </div>
</template>
